import React, { useEffect, useRef } from "react";
import { broadcastResponseToMainFrame } from "@azure/msal-browser/redirect-bridge";
import { Box, Typography } from "@mui/material";

/**
 * Bridge component for MSAL redirect responses in a secondary window (popup/child tab).
 */
const MsalRedirectBridge = ({ isAuth }: {
    isAuth: boolean;
}): React.ReactElement | null => {
    const hasBroadcastRef = useRef(false);

    useEffect(() => {
        if (!isAuth) {
            return;
        }

        if (hasBroadcastRef.current) {
            return;
        }

        // StrictMode re-runs effects in dev; guard to avoid double broadcast/close.
        hasBroadcastRef.current = true;

        const finalizeAuthentication = async (): Promise<void> => {
            try {
                await broadcastResponseToMainFrame();
            } finally {
                window.close();
            }
        };

        void finalizeAuthentication();
    }, [isAuth]);

    if (!isAuth) {
        return null;
    }

    return (
        <Box>
            <Typography>Signing in...</Typography>
        </Box>
    );
};

export default MsalRedirectBridge;
